import { masterServiceBaseUrl } from "services/http";
import { endpoint } from "../../../common/constant";
import {
  fetchAllPostPromisedData,
  fetchAllPromisedData,
  httpGet,
  httpPostCall,
} from "../../../common/utils/methods/commonMethods/utilityMethod";
import { successToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";

export const getChargesByApplicationId = (applicationId, state) => {
  const url = `${endpoint.paymentCollection.getApplicationCharges}/${applicationId}`;
  return httpGet(url, true, true, state);
};

export const getFailedChequeDetails = (request) => {
  const url = `${endpoint.paymentCollection.getFailedCheckDetails}`;
  return fetchAllPostPromisedData(url, request);
};

export const getPaymentStatus = (txnId, vendorType = "", businessAreaId) => {
  const url = `${endpoint.paymentCollection.getPaymentStatus}/${businessAreaId}/${txnId}?vendorType=${vendorType}`;
  return fetchAllPromisedData(url, true);
};

export const initiatePOSPayment = (request, vendorType = "", state) => {
  const url = `${endpoint.paymentCollection.initiatePayment}?vendorType=${vendorType}`;
  return httpPostCall(url, request, "post", true, { state });
};

export const cancelTransaction = (request, vendorType = "PAYTM_LINK") => {
  const url = `${endpoint.paymentCollection.cancelTransaction}?vendorType=${vendorType}`;
  return fetchAllPostPromisedData(url, request, "post");
}

export const getJodoHistory = (psId) => {
  const url = `${endpoint.paymentCollection.getJodoHistory}/${psId}`;
  return fetchAllPromisedData(url, true);
};

export const fetchPosFlagService = (buId) => {
  return fetchAllPromisedData(
    `${endpoint?.featureSetup?.getFeatureSetup}/${buId}?offset=${0}`
  );
};

export const getAdjustmentAmount = (studentBasicDetails, payMode) => {
  const request = {
    transferInApplicationId:
      payMode == "ADJ" ? studentBasicDetails?.applicationId : null,
    transferOutApplicationId: studentBasicDetails?.transferOutApplicationId ?? studentBasicDetails?.transferApplicationId,
    psid: studentBasicDetails?.psid,
    payMode: payMode,
    applicationId: payMode != "ADJ" ? studentBasicDetails?.applicationId : null,
  };
  const url = `${endpoint.paymentCollection.getOutstandingAmountByApplicationIdAndPsid}`;
  return fetchAllPostPromisedData(url, request, "post");
};

export const getTermDate = async (termId) => {
  const url = `${masterServiceBaseUrl}/termDateMaster/getTermDateByTermMapping/${termId}`;
  const res = await fetchAllPromisedData(url, true);
  try {
    if (res?.code == 200) return res?.data[0]?.termStartDate;
  } catch (error) {
    console.log(error);
  }
};

export const getMaxPaymentModeLimit = async () => {
  const url = endpoint?.depositSlip?.getAll;
  try {
    const response = await fetchAllPromisedData(url, true);
    if (response?.code == 200) return response?.data;
  } catch (error) {
    console.log(error);
  }
};

export const getDepositSlipInfoByApplication = async (appId) => {
  const url = `${endpoint?.getDepositSlipInfoByApplication}/${appId}`;
  try {
    const response = await fetchAllPromisedData(url, true);
    if (response?.code == 200) return response?.data;
  } catch (error) {
    console.log(error);
  }
};
export const getFeeConfiguration = async (request) => {
  const url = `${endpoint?.sdChargePayment?.search}?offset=${0}&pageSize=${2}`;
  try {
    return fetchAllPostPromisedData(url, request, "post");
  } catch (error) {
    console.log(error);
  }
};

export const getStudentDetails = (applicationId, opportunityOwnerId) => {
  if (!applicationId) return Promise.resolve([]);
  return fetchAllPostPromisedData(
    `${endpoint.getStudentChargesList}?offset=${0}`,
    { applicationId, opportunityOwnerId },
    "post"
  );
};

export const handleVoucherRetrieval = async (req) => {
  const { buId, vendorId, vendorType, retryTransactionId } = req;
  const url = `${endpoint.paymentCollection.getPaymentStatus}/${buId}/${vendorId}?vendorType=${vendorType}&successTxnRefId=${retryTransactionId}`;
  try {
    const response = await fetchAllPromisedData(url, true);
    if (response?.code == 200) {
      if (response?.data?.status == 'FAILED') {
        failureToast('Voucher retrieved failed');
        return false;
      }
      else {
        successToast('Voucher retrieved successfully');
        return true;
      }
    }
    else {
      failureToast(response?.message);
      return false
    };
  } catch (error) {
    console.log(error);
  }
}